//@ts-ignore
export const GAMESNACKS = window.GAMESNACKS || {};